import React, { useState } from 'react';
import InputComponent from '../InputComponent';
import PhoneNumberInput from '../PhoneNumberInput';
import './profileeditor.scss';
export default function ProfileEditor(props) {
  const { value, setValue, labelText, type, setIsChangeInData } = props;

  return (
    <div className="pe-container">
      <div className="lable">{labelText}</div>
      {type === 'phone' ? (
        <PhoneNumberInput value={value} setIsChangeInData={setIsChangeInData} setValue={setValue} />
      ) : type === 'email' ? (
        <InputComponent isDisabled={true} inputStyle="pe-input" value={value}></InputComponent>
      ) : (
        <div className="input-container">
          <InputComponent
            inputStyle="pe-input"
            type="text"
            // placeholder={type === 'role' ? 'Business Development' : type === 'org' ? 'Ance Inc' : 'John doe'}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setIsChangeInData(true);
            }}
          ></InputComponent>
        </div>
      )}
    </div>
  );
}
